module.exports = __webpack_public_path__ + "static/akase-5cad661c64ba883e519c4aca88afd4a5.png";